/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'
import Select from 'react-select'

class CreateLocationStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      familyChanges: [],
      processId: null
    }
  }

  submit(e) {
    e.preventDefault()
  }

  componentDidMount() {
    return http
      .get(`process/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          let familyChanges = res.data.object
          familyChanges.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            familyChanges
          })
        }
      })
      .catch((err) => {})
  }

  changeFamily = (processId) => {
    this.setState({
      processId
    })
  }

  createCartStation() {
    let title = document.getElementById('title').value.trim()
    let sortOrder = document.getElementById('sortOrder').value.trim()
    let processId = this.state.processId === '' || this.state.processId === null ? '' : this.state.processId.id
    if (title === '' || processId === '') {
      message.error('فیلد های ستاره دار انتخاب شود')
    } else {
      let data = {
        title,
        sortOrder,
        processId
      }
      http
        .post(`deliveryStatus/location/create`, data, {})
        .then((res) => {
          if (res.data.error === null) {
            message.success(' با موفقیت اضافه شد')
            setTimeout(() => {
              window.location.assign('/base/deliveryStatus/reportLocationStatus')
            }, 3000)
          } else {
            message.error(res.data.description)
          }
        })
        .catch(() => {})
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>افزودن آیتم انتخابی</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن آیتم انتخابی</p>
            </div>
            <div className="formComponent selectComponent">
              <label>
                عنوان :<span className="requireFiled">*</span>‌
              </label>
              <input type="text" id="title" className="form-control" />
            </div>
            <div className="formComponent selectComponent">
              <label>
                خانواده تغییرات <span className="requireFiled">*</span>
              </label>
              <Select
                value={this.state.processId}
                onChange={this.changeFamily}
                options={this.state.familyChanges}
                isMulti={false}
                isClearable={true}
                placeholder={''}
                id="providerId"
                name="providerId"
                tabIndex="1"
              />
            </div>
            <div className="formComponent selectComponent">
              <label>ترتیب نمایش :‌</label>
              <input type="number" id="sortOrder" className="form-control" />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.createCartStation.bind(this)}>
                افزودن
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateLocationStatus
